import { alpha, Stack } from "@mui/material";
import Iconify from "src/components/Iconify";
import palette from "src/theme/palette";

// ----------------------------------------------------------------------

const sx = {
	position: "absolute",
	backgroundColor: alpha(palette.light.primary.main, 0.5),
	height: "100%",
	width: "100%",
	alignItems: "center",
	justifyContent: "center"
};

export const MaintananceLayer = () => {
	return (
		<Stack sx={sx}>
			<Iconify icon={"entypo:tools"} height={45} width={45} color='text.primary' />
		</Stack>
	);
};

export default MaintananceLayer;
